import { FC } from 'react';

const TwitterIcon: FC = () => {
    return (
        <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M18.5326 13.9627L28.4429 2.69629H26.0944L17.4894 12.4788L10.6165 2.69629H2.68945L13.0826 17.4891L2.68945 29.3037H5.03801L14.1252 18.973L21.3835 29.3037H29.3105L18.532 13.9627H18.5326ZM15.3159 17.6194L14.2629 16.1464L5.88422 4.42534H9.49146L16.2531 13.8846L17.3062 15.3576L26.0956 27.6532H22.4883L15.3159 17.62V17.6194Z"
                fill="#0A163C"
            />
        </svg>
    );
};

export { TwitterIcon };
